import moment from 'moment';
import * as axiosOrig from 'axios';
import { stringify } from 'qs';

export const breakpoints = {
    tiny: '(max-width: 374px)',
    palm: '(max-width: 767px)',
    lap: '(min-width: 768px) and (max-width: 1023px)',
    portable: '(max-width: 1023px)',
    'lap-and-up': '(min-width: 768px)',
    desk: '(min-width: 1024px)',
    'desk-wide': '(min-width: 1200px)',
    header: '(min-width: 1105px)',
};

export const modulo = (num, div) => ((num % div) + div) % div;

export const closePopups = () => {
    const event = new CustomEvent('close-popups', {});
    document.dispatchEvent(event);
};

export const openPopups = () => {
    const event = new CustomEvent('open-popups', {});
    document.dispatchEvent(event);
};

export const openSecondaryPopups = () => {
    const event = new CustomEvent('open-secondary-popups', {});
    document.dispatchEvent(event);
};

export const formatDate = (start, end = null) => {
    const startDate = moment(start);
    const endDate = end ? moment(end) : null;

    const month = 'MMM';
    const day = 'D';
    const year = 'YYYY';
    const singleDate = !end || startDate.isSame(endDate, 'day');
    let dateString = null;

    if (singleDate) {
        dateString = startDate.format(`${day} ${month} ${year}`);
    } else {
        const sameMonthEvent = startDate.isSame(endDate, 'month');
        const startDateString = sameMonthEvent ? startDate.format(`${day} - `) : startDate.format(`${day} ${month} - `);
        const endDateString = endDate.format(`${day} ${month} ${year}`);
        dateString = startDateString + endDateString;
    }

    return dateString;
};

export const axios = (() => {
    return axiosOrig.create({
        baseURL: '/',
        headers: {
            'X-CSRF-Token': window.csrfTokenValue,
        },
        transformRequest: [(data) => stringify(data)],
    });
})();

export const fetchTemp = async ({ lat, lng }) => {
    try {
        const response = await axios.get('/api/job/temp.json', {
            params: {lat, lng}
        });

        return response.data.temperature;
    } catch (err) {
        return new Error(err);
    }
};

// Calculate total system size in Watts
// given an array of system (a configuration)
export const calculateSystemSize = (systems) => {
    return systems.reduce((total, system) => {
        const panelTotal = system.mppts.reduce((acc, mppt) => {
            const mpptTotal = mppt.panel ? mppt.panel.details.powerRating * mppt.series * mppt.parallel : 0;
            return acc + mpptTotal;
        }, 0);
        return total + panelTotal;
    }, 0);
};

export default breakpoints;
